import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as cortexRoutes } from './cortex/cortex.routes';
import { routes as kanbanRoutes } from './kanban/kanban.routes';
import { routes as flowbuilderRoutes } from './flowbuilder/flowbuilder.routes';
import { routes as changelogRoutes } from './changelog/changelog.routes';
import { routes as dashboardAppRoutes } from './dashboardApps/dashboardApps.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import ShopifySelectAccount from './shopify/SelectAccount.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL(''),
      name: 'dashboard_root',
    },
    {
      path: frontendURL('shopify/select-account'),
      name: 'shopify_select_account',
      component: ShopifySelectAccount,
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...cortexRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...kanbanRoutes,
        ...flowbuilderRoutes,
        ...changelogRoutes,
        ...dashboardAppRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
